// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bodiesContainer0 {
  width: 100%;
  height: 100%;
  background-color: rgb(230, 230, 230);
  text-align: center;
  position: relative;
  margin: 0;
  padding: 0;
}


#bodiesContainer {
  display: grid;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.layout-1 {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
}

.layout-2 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
}

.layout-3,
.layout-4 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.visualizationWrapper {
  display:flex;
  flex-direction:column;
  box-sizing:border-box;
}

.arrayContainer {
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.mirrored-array-container {
  display: inline-block;
  /* position: relative; */
}

.break-line {
  position: relative;
  top: 50%;
  left: -1000%;
  width: 1750%;
  height: 2px;
  background-color: black;
  transform: translateY(-50%);
  z-index: 0;
}

#bodyContainer {
  height:calc(100% - 200px);
  width:100%;
  text-align:center;
  overflow:hidden;
  margin-top:0;
  transform: scale(0.85);
  top: -150px;
}

.arrayElement {
  padding-top: 7px;
  margin-bottom: 3px;
  font-family: sans-serif;
  font-weight: 700;
  display: inline-block;
}

.arrayElement-bottom {
  padding-top: 7px;
  padding-bottom: 7px;
  margin-top: 2px;
  font-family: sans-serif;
  font-weight: 700;
  display: inline-block;
}

.mirrored-array-container p {
  font-size: 7px;
  color: black;
}

/* Bar styles for consolidated algorithm visualization */
.bar {
  display: inline-block;
  margin: 0 var(--bar-gap, 2px);
  width: var(--bar-width, 8px);
  background-color: var(--color-bar-default, #4a90e2);
  border-radius: 2px;
  position: relative;
  transition: all 0.2s ease;
  vertical-align: bottom;
}

.bar span {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  color: #333;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

/* Algorithm-specific focus states */
.bar.compare {
  background-color: var(--color-compare, #ff6b6b);
  transform: scale(1.1);
}

.bar.swap {
  background-color: var(--color-swap, #4ecdc4);
  animation: swap-pulse 0.3s ease-in-out;
}

.bar.sorted {
  background-color: var(--color-sorted, #45b7d1);
}

.bar.pivot {
  background-color: var(--color-pivot, #ffd93d);
  border: 2px solid #333;
}

.bar.shell-focus {
  background-color: var(--color-shell, #a8e6cf);
  outline: 2px dashed #4caf50;
}

.bar.insertion-focus {
  background-color: var(--color-insertion, #ffb3ba);
  outline: 2px solid #e91e63;
}

.bar.selection-focus {
  background-color: var(--color-selection, #bae1ff);
  outline: 2px solid #2196f3;
}

.bar.bucket-focus {
  background-color: var(--color-bucket, #d4b2d4);
  outline: 2px solid #9c27b0;
}

.bar.counting-focus {
  background-color: var(--color-counting, #c7ff8c);
  outline: 2px solid #8bc34a;
}

@keyframes swap-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
}

/* Responsive bar sizing */
@media (max-width: 768px) {
  .bar {
    margin: 0 1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Body/Body.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;EAEE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;EAC5B,mDAAmD;EACnD,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["#bodiesContainer0 {\n  width: 100%;\n  height: 100%;\n  background-color: rgb(230, 230, 230);\n  text-align: center;\n  position: relative;\n  margin: 0;\n  padding: 0;\n}\n\n\n#bodiesContainer {\n  display: grid;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.layout-1 {\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n}\n\n.layout-2 {\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr;\n}\n\n.layout-3,\n.layout-4 {\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n}\n\n.visualizationWrapper {\n  display:flex;\n  flex-direction:column;\n  box-sizing:border-box;\n}\n\n.arrayContainer {\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.mirrored-array-container {\n  display: inline-block;\n  /* position: relative; */\n}\n\n.break-line {\n  position: relative;\n  top: 50%;\n  left: -1000%;\n  width: 1750%;\n  height: 2px;\n  background-color: black;\n  transform: translateY(-50%);\n  z-index: 0;\n}\n\n#bodyContainer {\n  height:calc(100% - 200px);\n  width:100%;\n  text-align:center;\n  overflow:hidden;\n  margin-top:0;\n  transform: scale(0.85);\n  top: -150px;\n}\n\n.arrayElement {\n  padding-top: 7px;\n  margin-bottom: 3px;\n  font-family: sans-serif;\n  font-weight: 700;\n  display: inline-block;\n}\n\n.arrayElement-bottom {\n  padding-top: 7px;\n  padding-bottom: 7px;\n  margin-top: 2px;\n  font-family: sans-serif;\n  font-weight: 700;\n  display: inline-block;\n}\n\n.mirrored-array-container p {\n  font-size: 7px;\n  color: black;\n}\n\n/* Bar styles for consolidated algorithm visualization */\n.bar {\n  display: inline-block;\n  margin: 0 var(--bar-gap, 2px);\n  width: var(--bar-width, 8px);\n  background-color: var(--color-bar-default, #4a90e2);\n  border-radius: 2px;\n  position: relative;\n  transition: all 0.2s ease;\n  vertical-align: bottom;\n}\n\n.bar span {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  color: #333;\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Algorithm-specific focus states */\n.bar.compare {\n  background-color: var(--color-compare, #ff6b6b);\n  transform: scale(1.1);\n}\n\n.bar.swap {\n  background-color: var(--color-swap, #4ecdc4);\n  animation: swap-pulse 0.3s ease-in-out;\n}\n\n.bar.sorted {\n  background-color: var(--color-sorted, #45b7d1);\n}\n\n.bar.pivot {\n  background-color: var(--color-pivot, #ffd93d);\n  border: 2px solid #333;\n}\n\n.bar.shell-focus {\n  background-color: var(--color-shell, #a8e6cf);\n  outline: 2px dashed #4caf50;\n}\n\n.bar.insertion-focus {\n  background-color: var(--color-insertion, #ffb3ba);\n  outline: 2px solid #e91e63;\n}\n\n.bar.selection-focus {\n  background-color: var(--color-selection, #bae1ff);\n  outline: 2px solid #2196f3;\n}\n\n.bar.bucket-focus {\n  background-color: var(--color-bucket, #d4b2d4);\n  outline: 2px solid #9c27b0;\n}\n\n.bar.counting-focus {\n  background-color: var(--color-counting, #c7ff8c);\n  outline: 2px solid #8bc34a;\n}\n\n@keyframes swap-pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.2); }\n}\n\n/* Responsive bar sizing */\n@media (max-width: 768px) {\n  .bar {\n    margin: 0 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
